import { render } from "./Payment.vue?vue&type=template&id=6bcb63d3&scoped=true&ts=true"
import script from "./scripts/payment.ts?vue&type=script&lang=ts"
export * from "./scripts/payment.ts?vue&type=script&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=6bcb63d3&lang=css"
import "./Payment.vue?vue&type=style&index=1&id=6bcb63d3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcb63d3"]])

export default __exports__